export default __webpack_public_path__ + "static/media/avatar08.5b040d90.svg";